import { random } from 'lodash-es'

import { certificateFromData } from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'
export default ({ value, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  const dataFormat = async (data: any) => {
    return {
      ...data,
      id: data?.id || random(100000)
    }
  }
  const add = () => {
    onOpen({ status: 'Add', editItem: {} })
  }

  const edit = (index: number) => {
    const fieldValues = value?.[index] || {}
    const attachments = certificateFromData(
      fieldValues?.attachment_files || fieldValues?.attachments || []
    )
    onOpen({ status: 'Edit', editItem: { ...fieldValues, attachments } })
  }

  const runSaveRewardPunishment = async (data: any) => {
    const healthItem = await dataFormat({ ...data })
    const isEdit = value?.findIndex((item: any) => item.id === healthItem.id) > -1
    const newHealthCertificates = value?.map((item: any) => {
      if (item.id === healthItem?.id) {
        return healthItem
      }
      return item
    })
    onConfirm(isEdit ? newHealthCertificates : [...(value || []), healthItem])
    onCancel()
  }

  const runDeleteHrmRewardPunishment = (data: any) => {
    const rest = value.filter((item: any) => item.id !== data.id?.[0])
    onConfirm(rest)
    onCancel()
  }

  // useEffect(() => {
  //   if (onConfirm) onConfirm(value)
  //   console.log('rewardPunishment:', toJS(value))
  // }, [value])
  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runDeleteHrmRewardPunishment,
    runSaveRewardPunishment,
    deleteHrmRewardPunishmentLoading: false,
    saveRewardPunishmentLoading: false
  }
}
